export default function getCreativeName(type, width = null, height = null, id) {
    if (type === 'banner') {
        return `Banner_${id} (${width}x${height})`
    } else if (type === 'textEmail') {
        return `Email_${id}`
    } else if (type === 'htmlEmail') {
        return `HTML_${id}`
    } else if (type === 'text') {
        return `Text_${id}`
    }
}